import Dexie, { type EntityTable } from 'dexie';
import type { ConversationMessageTypeUnion } from '@/models/conversations/conversation';

export const messageDb = new Dexie('chat-database') as Dexie & {
  sessionMessages: EntityTable<ConversationMessageTypeUnion, 'ID'>;
  groupMessages: EntityTable<ConversationMessageTypeUnion, 'ID'>;
};

messageDb.version(3).stores({
  sessionMessages: 'ID, UserID, CreateTime, RetrieveTime, ChatSessionID, [ChatSessionID+UserID]',
  groupMessages: 'ID, UserID, CreateTime, RetrieveTime, GroupID, [GroupID+UserID]',
});
